import { combineReducers } from "redux";

import users from "./User";
import tournaments from "./Tournaments";
import payment from "./Payment";

export default combineReducers({ tournaments, users, payment });
